:host {
  /* --rzf-carousel__progress-bar--height: 4px;
  --rzf-carousel__progress-bar--color: #007bff;
  --rzf-carousel__progress-bar--background: #e0e0e0;
  --rzf-carousel__progress-bar--height: 10px;
  --rzf-carousel__progress--transition: width 0.5s ease-in-out;
  --rzf-carousel__progress-bar--padding: 0px; */

  --rzf-carousel--gap: 12px;
  --rzf-carousel__dots--padding: 14px 0;
  --rzf-carousel--font-size-title: 2rem;
  --rzf-carousel--font-size-subtitle: 1.5rem;
  --rzf-carousel--color-subtitle: #666;
  --rzf-carousel__dot--size: 14px;
  --rzf-carousel__dot--border-color: #D11112;
  --rzf-carousel__dot--active-background: #D11112;
  --rzf-carousel__dot--border-radius: 30px;


  --rzf-carousel__keen-slider--font-size: inherit;
  --rzf-carousel__dot--border-width: 2px;
  --rzf-carousel__keen-slider--padding: 9.5px 27px;
  --rzf-carousel__keen-slider--border-radius: 50px;
  --rzf-carousel__keen-slider__bg--hover:rgba(207, 17, 18, 0.1);

  display: block;
  height: 100%;
  width: 100%;
}

*:not(:defined) {
  display: none;
}

.rzf-carousel {
  position: relative;
  height: 100%;
  display: grid;
  grid-template-rows: min-content 1fr min-content 1fr;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "header header header"
    "prev slider next"
    "dots dots dots"
    "progress-bar progress-bar progress-bar"
    "content content content";
}

.rzf-carousel--full {
  grid-template-rows: min-content 1fr min-content min-content 1fr;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "header header header"
    "prev slider next"
    "dots dots dots"
    "progress-bar progress-bar progress-bar"
    "content content content";
}

.rzf-carousel--basic {
  grid-template-rows: min-content 1fr 1fr;
  grid-template-columns: repeat(1fr, 3);
  grid-template-areas:
    "header header header"
    "slider slider slider"
    "content content content";
}

.rzf-carousel--no-navigation {
  grid-template-areas:
    "header header header"
    "slider slider slider"
    "dots dots dots"
    "progress-bar progress-bar progress-bar"
    "content content content";
}

.rzf-carousel--no-progress-bar {
  grid-template-columns: auto 1fr auto;
  grid-template-rows: min-content 1fr min-content min-content;
  grid-template-areas:
    "header header header"
    "prev slider next"
    "dots dots dots"
    "content content content";
}

.rzf-carousel--no-dots {
  grid-template-rows: min-content min-content min-content 1fr;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "header header header"
    "prev slider next"
    "progress-bar progress-bar progress-bar"
    "content content content";
}

.rzf-carousel--dots-only {
  grid-template-columns: auto 1fr auto;
  grid-template-rows: min-content 1fr min-content 1fr;
  grid-template-areas:
    "header header header"
    "slider slider slider"
    "dots dots dots"
    "content content content";
}

.rzf-carousel--navigation-only {
  grid-template-columns: auto 1fr auto;
  grid-template-rows: min-content 1fr 1fr;
  grid-template-areas:
    "header header header"
    "prev slider next"
    "content content content";
}

.rzf-carousel--progress-bar-only {
  grid-template-areas:
    "header header header"
    "slider slider slider"
    "progress-bar progress-bar progress-bar"
    "content content content";
}

.rzf-carousel__header {
  grid-area: header;
  text-align: center;
  display: grid;
  place-items: center;
}

::slotted([slot="title"]) {
  font-size: var(--rzf-carousel--font-size-title);
  margin: 0;
}

::slotted([slot="subtitle"]) {
  font-size: var(--rzf-carousel--font-size-subtitle);
  margin: 0;
  color: var(--rzf-carousel--color-subtitle);
}

::slotted([slot="slider"]),
::slotted([slot="content"]) {
  display: flex;
  overflow: hidden;
  position: relative;
  height: 100%;
}

.keen-slider > slot {
  display: flex;
  overflow: hidden;
  position: relative;
}

.rzf-carousel__main-slider {
  grid-area: slider;
  overflow: hidden;
}

.keen-slider__next,
.keen-slider__prev {
  align-self: center;
  background: none;
  border: none;
  font-size: var(--rzf-carousel__keen-slider--font-size);
  cursor: pointer;
  height: fit-content;

  padding: var(--rzf-carousel__keen-slider--padding);
  border-radius: var(--rzf-carousel__keen-slider--border-radius);
}

.keen-slider__next:hover,
.keen-slider__prev:hover {
  background: var(--rzf-carousel__keen-slider__bg--hover);
}

.keen-slider__next {
  grid-area: next;
}

.keen-slider__prev {
  grid-area: prev;
}

.rzf-carousel__dots {
  grid-area: dots;
  display: flex;
  place-content: center;
  gap: var(--rzf-carousel--gap);
  padding: var(--rzf-carousel__dots--padding);
}

.rzf-carousel__dot {
  cursor: pointer;
  width: var(--rzf-carousel__dot--size);
  height: var(--rzf-carousel__dot--size);
  border-radius: var(--rzf-carousel__dot--border-radius);
  border: var(--rzf-carousel__dot--border-width) solid var(--rzf-carousel__dot--border-color);
  box-sizing: border-box;
}

.rzf-carousel__dot--active {
  border-radius: var(--rzf-carousel__dot--border-radius);
  background: var(--rzf-carousel__dot--active-background);
}

::slotted([slot="progressBar"]) {
  grid-area: progress-bar;
}

/* .rzf-carousel__progress-bar {
  grid-area: progress-bar;
  height: var(--rzf-carousel__progress-bar--height);
  padding: var(--rzf-carousel__progress-bar--padding);
}

.rzf-carousel__progress {
  width: 0%;
  height: 100%;
  background-color: var(--rzf-carousel__progress-bar--color);
  transition: var(--rzf-carousel__progress--transition);
} */

.rzf-carousel__content-slider {
  grid-area: content;
}
